import { useState, Fragment } from "react";
import { Row } from "reactstrap";
import ArrowRightIos from "../../assets/ArrowRightIos";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import './index.scss'

const CommonAccordian = (props) => {

  const [exapnded, setExanded] = useState([])

  const handleChange = (id) => {
    let array = [...exapnded]
    let index = array.findIndex(val => val == id)
    if (index != -1) {
      array.splice(index , 1)
    }else{
      array.push(id)
    }
    setExanded(array)
  }

  const renderRows = () => {
    return props && props.array.map((val, index) => {
      return (
        <Accordion  key={index} expanded={exapnded.includes(val.id)} onChange={() => handleChange(val.id)}>
          <AccordionSummary aria-controls="panel1a-content">
            <Row className="faqContainer">
              <div className="arrowIconCon">
                {!exapnded.includes(val.id) ? <ArrowRightIos /> : <ExpandMoreIcon style={{ color :'#fff', fontSize:26 }} />}
              </div>
              <h3>
                {val.question}
              </h3>
            </Row>
          </AccordionSummary>
          <AccordionDetails>
            <div dangerouslySetInnerHTML={{ __html: val.answer }} />
          </AccordionDetails>
        </Accordion>
      )
    })
  }

  return (
    <div className="commonAcc">
      {renderRows()}
    </div>
  )
}

export default CommonAccordian;